import {
  ChangeDetectorRef, Component, Input, OnChanges, Inject, OnInit, SimpleChanges
} from '@angular/core';
import { filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { isNilOrEmpty } from 'helpers';
import { Router } from '@angular/router';
import { WithChangesSubject } from 'core/mixins/with-changes-subject';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import {
  EntityPublicInfoFragment,
  GetEntityById2,
  GetEntityById2GQL
} from 'generated/graphql';
import { FormControl, FormGroup } from '@angular/forms';

/**
 * Format of data for the dialog
 */
export interface MergeEntitiesDialogData {
  campaignId: string;
  entityId: string;
  entityTypeId: string;
}

@Component({
  selector: 'app-merge-entities-dialog',
  templateUrl: './merge-entities.dialog.html',
  styleUrls: ['./merge-entities.dialog.scss']
})
export class MergeEntitiesDialog extends WithDisposableSubject(WithChangesSubject(class { })) implements OnInit, OnChanges {

  selectedEntity: EntityPublicInfoFragment;

  entity: GetEntityById2.GetEntity;


  constructor(
    private _getEntityGQL: GetEntityById2GQL,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    public dialogRef: MatDialogRef<MergeEntitiesDialog>,
    @Inject(MAT_DIALOG_DATA) public data: MergeEntitiesDialogData
  ) {
    super();
  }

  static open(dialog: MatDialog, config: MatDialogConfig<MergeEntitiesDialogData>) {
    return dialog.open(MergeEntitiesDialog, config);
  }

  close() {
    this.dialogRef.close();
  }

  submitIfSelected(event: any) {
    if (this.selectedEntity) {
      this.onBeginMergeClicked();
    }
  }

  entitySelected(event: any) {
    this.selectedEntity = event;
  }

  excludeEntitiesFn(entityId: string) {
    return function(results: EntityPublicInfoFragment[]) {
      return results.filter(e => e.id !== entityId);
    };
  }

  ngOnInit(): void {
    this.watchForChangeKeys('entityId', 'campaignId').pipe(
      startWith<any, any>(null),
      takeUntil(this.disposer),
      map(() => ({ campaignId: this.data.campaignId, entityId: this.data.entityId })),
      filter(({ campaignId, entityId }) => !!campaignId && !!entityId),
      switchMap(({ campaignId, entityId }) => this._getEntityGQL.watch({
        entityId, campaignId,
        withBestAddress: false,
        withToplines: false,
        withBestPhone: false,
        withBestEmail: false
      }, {
        fetchPolicy: 'cache-first'
      }).valueChanges),
      takeUntil(this.disposer),
      map(({ data }) => data?.getEntity)
    ).subscribe((entity) => {
      this.entity = entity;
      this._cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  onBeginMergeClicked() {
    this._router.navigate(['/entity/merge'], {
      queryParams: {
        campaignId: this.data.campaignId,
        targetEntityId: this.data.entityId,
        sourceEntityId: this.selectedEntity.id
      },
      queryParamsHandling: 'merge'
    });
    this.close();
  }
}
